<div class="layout-row layout-align-start-center full-height" *ngIf="progress" [ngbTooltip]="progressBarTooltip" openDelay="300" triggers="hover">
  <div class="progress flex layout-row margin-right-5">
    <div class="progress-bar" [ngClass]="{'disable-transition': isDisableTransition}"
         role="progressbar" [style.width]="progressValuePercentage + '%'" aria-valuemin="0"
         aria-valuemax="100"></div>
  </div>
  <span class="br-caption-1">{{progress.stepNumber}}/{{progress.numberOfSteps}}</span>
  <ng-template #progressBarTooltip>
    <app-service-progress-tooltip [serviceType]="serviceType"
                                  [progress]="progress"></app-service-progress-tooltip>
  </ng-template>
</div>
